// @ts-nocheck

import { mapState } from 'pinia';
import { useCompanyStore } from '@/stores/company';
import { generateIntercomIdentityHash } from '@/modules/user/AuthService';
import { generalAppVariables } from '@/constants';
import IUser from '@/modules/user/IUser';

export const IntercomMixin = {
  data() {
    return {};
  },
  computed: {
    ...mapState(useCompanyStore, ['companies']),
  },
  methods: {
    async initIntercom(user: IUser | null = null) {
      const appId = generalAppVariables.INTERCOM_APP_ID;
      const apiBase = generalAppVariables.INTERCOM_API_BASE;

      let intercomBootPayload: {
          api_base: string,
          app_id: string,
          email?: string,
          created_at?: string,
          name?: string,
          user_hash?: string,
        } = {
          app_id: appId,
          api_base: apiBase,
        };

      if (!appId) {
        console.info('No Intercom App ID found in environment variables');
        return;
      }

      if (!window.Intercom) {
        console.info('Intercom not loaded yet');
        return;
      }

      if (user) {
        const hashResponse = await generateIntercomIdentityHash();

        if (hashResponse.isOk()) {
          const userHash = hashResponse.value.payload;

          intercomBootPayload = {
            ...intercomBootPayload,
            email: user.email,
            created_at: user.createdAt,
            name: `${user.firstName} ${user.lastName}`,
            user_hash: userHash,
          };
        }
      }

      window.Intercom('boot', intercomBootPayload);
    },
    formatCompaniesForIntercom() {
      return this.companies.map((company: { company: string }) => ({
        id: company.name,
        name: company.name,
        created_at: company.createdAt,
        'Record type': 'Company',
      }));
    },
  },
};
